export default __webpack_public_path__ + "static/media/04.2160db59.png";